import request from "../utils/request"

export function applyauth(data) {
    return request({
        url: '/us3/applyAuth',
        method: 'post',
        data
    })
}

export function applyurlauth(data) {
    return request({
        url: "/us3/applyPrivateUrlAuth",
        method: 'post',
        data
    })
}